export default Object.freeze({
  E_ALIGNER: 'E-Aligner',
  DPI: 'DPI',
  LYRA: 'Lyra',
  LAB: 'Laboratoire',
});
